import { ChevronLeftIconRounded, SminexPlugIcon } from '@shared/assets/icons';
import { IconButton } from '@shared/ui/icon-button';
import styles from './styles.module.scss';

interface AccessDeniedProps {
  onBack: () => void;
}

export const AccessDenied = ({ onBack }: AccessDeniedProps) => (
  <div className={styles.container}>
    <IconButton onClick={onBack} icon={<ChevronLeftIconRounded />} variant="primary" size="small">
      Назад
    </IconButton>

    <div className={styles.content}>
      <SminexPlugIcon />
      <p className={styles.title}>Нет доступа</p>
      <p className={styles.subtitle}>У вас нет прав для просмотра этого мероприятия</p>
    </div>
  </div>
);
